export default __webpack_public_path__ + "static/media/SQLServerNewLogin.387f3efd.png";